import React, { useState } from "react";
import { Divider, Modal, Typography } from "antd";
import { IoClose } from "react-icons/io5";
import { MdOutlineArrowOutward } from "react-icons/md";

import { ExclamationCircleFilled } from "@ant-design/icons";
import PrimaryButton from "../Forms/PrimaryButton";
import { roundDecimal } from "../../utils";
import ProductImageName from "../Layout/ProductImageName";

const { Title } = Typography;

export default function DeleteOrderItemModal({
  open,
  onClose,
  handleSubmit,
  productToEdit,
  title = "Do you want to delete this item?",
  loading,
}) {
  return (
    <Modal
      className="form-css custom-modal rounded-lg shadow-xl status-modal"
      open={open}
      footer={null}
      onCancel={onClose}
      width={350}
      centered
    >
      {/* Header */}
      <div className="flex justify-between items-center">
        <Title level={2} className="text-xl font-semibold text-gray-800 font-abhaya">
          {title}
        </Title>
      </div>

      {/* Product Details */}
      <div className="w-full bg-white p-4 rounded-lg shadow-sm flex items-center border border-gray-200">
        {/* <div className="w-16 h-16 bg-gray-200 rounded-lg mr-4 overflow-hidden">
                    <img
                        src={productToEdit?.product_picture_url}
                        alt={productToEdit?.short_name}
                        className="w-full h-full object-cover"
                    />
                </div> */}
        <div className="w-16 h-16 rounded-lg mr-4 overflow-hidden flex items-center justify-center">
          {productToEdit?.product_picture_url && (
            <ProductImageName
              img_url={productToEdit.product_picture_url}
              img_alt={productToEdit.short_name}
            />
          )}
        </div>
        <div>
          <div className="font-semibold text-lg">{productToEdit?.short_name}</div>
          <div className="text-sm text-gray-500">{productToEdit?.shade_name}</div>
        </div>
      </div>

      {/* Product Stats */}
      <div className="flex justify-between items-center mb-4 text-black font-semibold px-2">
        <span>Total Cases - {productToEdit?.update_total_cases || productToEdit?.cases}</span>
        <Divider type="vertical" />
        <span>
          Total Meters -{" "}
          {roundDecimal(productToEdit?.update_total_meter || productToEdit?.quantity_meters)}m
        </span>
      </div>

      {/* Delete Button */}
      <div className="w-full flex justify-center">
        <PrimaryButton
          text="Delete Item"
          onClick={handleSubmit}
          loading={loading}
          className="me-[30px]"
        />
      </div>
    </Modal>
  );
}
